import axios from "axios";
import { store } from "../../redux/store/store";

const axioInstance = axios.create();

// Request Interceptor
axioInstance.interceptors.request.use(
  (config) => {
    const token = store.getState().auth.authToken;
    const tokenType = store.getState().auth.tokenType;

    if (token && tokenType) {
      config.headers["Authorization"] = `${tokenType} ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
axioInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axioInstance;
